var BASWebServices;
(function (BASWebServices) {
    var MessageBoxController = (function () {
        function MessageBoxController($scope, $rootScope, $sce, $http) {
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$sce = $sce;
            this.$http = $http;
            this.$scope.mbc = this;
            this.$scope.messages = new Array();
            this.$scope.showSuccess = true;
            this.$scope.showWarning = true;
            this.$scope.showError = true;
            var _this = this;
            this.$rootScope.$on('messageForBox', function (args, type, shortMessage, additionalInfo, shortMessageContainsSafeHtml, longMessageContainsSafeHtml) {
                if (additionalInfo === undefined) {
                    additionalInfo = '- no additional info -';
                }
                _this.addNewMessage(type, shortMessage, additionalInfo, shortMessageContainsSafeHtml, longMessageContainsSafeHtml);
            });
            this.$rootScope.$on('messageBoxIgnoreOldMessages', function (args) {
                _this.ignoreOldMessages();
            });
        }
        MessageBoxController.prototype.reset = function () {
            this.$scope.messages = this.$scope.messages.slice(0, 0);
        };
        MessageBoxController.prototype.ignoreOldMessages = function () {
            for (var i = 0; i < this.$scope.messages.length; i++) {
                var currMessage = this.$scope.messages[i];
                currMessage.setIgnored();
            }
        };
        MessageBoxController.prototype.copyMessagesToClipboard = function () {
            var text = "";
            for (var _i = 0, _a = this.$scope.messages; _i < _a.length; _i++) {
                var message = _a[_i];
                text += "#########\n";
                text += "(" + message.getDateString() + ") " + message.getType() + ": " + message.getShortMessage() + "\n";
                text += message.getLongMessageUnmodified() + "\n";
                text += "\n";
            }
            if (!text) {
                text = "No log messages yet";
            }
            this.copyTextToClipboard(text);
        };
        MessageBoxController.prototype.fallbackCopyTextToClipboard = function (text) {
            var textArea = document.createElement("textarea");
            textArea.value = text;
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                var successful = document.execCommand('copy');
                var msg = successful ? 'successful' : 'unsuccessful';
                console.log('Copy messages to clipboard (fallback API): Copying text command was ' + msg);
                if (successful) {
                    alert("Copied log messages to clipboard.");
                }
            }
            catch (err) {
                console.error('Copy messages to clipboard (fallback API): Oops, unable to copy', err);
            }
            document.body.removeChild(textArea);
        };
        MessageBoxController.prototype.copyTextToClipboard = function (text) {
            if (!(navigator.clipboard)) {
                this.fallbackCopyTextToClipboard(text);
                return;
            }
            navigator.clipboard.writeText(text).then(function () {
                console.log('Copy messages to clipboard (navigator.clipboard API): Copying to clipboard was successful!');
                alert("Copied log messages to clipboard.");
            }, function (err) {
                console.error('Copy messages to clipboard (naviagator.clipboard API): Could not copy text: ', err);
            });
        };
        MessageBoxController.prototype.addNewMessage = function (type, shortMessage, longMessage, shortMessageContainsSafeHtml, longMessageContainsSafeHtml) {
            this.$scope.messages.push(new MessageEntry(this.$sce, type, new Date(), shortMessage, longMessage, false, shortMessageContainsSafeHtml, longMessageContainsSafeHtml));
        };
        return MessageBoxController;
    }());
    BASWebServices.MessageBoxController = MessageBoxController;
    var MessageEntry = (function () {
        function MessageEntry($sce, type, date, shortMessage, longMessage, ignored, shortMessageContainsSafeHtml, longMessageContainsSafeHtml) {
            this.$sce = $sce;
            this.type = type;
            this.date = date;
            this.shortMessage = shortMessage;
            this.longMessage = longMessage;
            this.ignored = ignored;
            this.shortMessageContainsSafeHtml = shortMessageContainsSafeHtml;
            this.longMessageContainsSafeHtml = longMessageContainsSafeHtml;
        }
        MessageEntry.prototype.sanitizeHtml = function (input, escapeQuotes, allowBr) {
            if (escapeQuotes === void 0) { escapeQuotes = false; }
            if (allowBr === void 0) { allowBr = false; }
            var changedString = input;
            if (!escapeQuotes) {
                changedString = changedString.replace(/"/g, '&quot;').replace(/'/g, "&apos;");
            }
            else {
                changedString = changedString.replace(/"/g, '\\&quot;').replace(/'/g, "\\&apos;");
            }
            changedString = changedString.replace(/</g, "&lt;").replace(/>/g, "&gt;");
            if (allowBr) {
                changedString = changedString
                    .replace(/&lt;br\/&gt;/g, "<br/>")
                    .replace(/&lt;br&gt;/g, "<br/>");
            }
            return changedString;
        };
        MessageEntry.prototype.getType = function () {
            return this.type;
        };
        MessageEntry.prototype.getDate = function () {
            return this.date;
        };
        MessageEntry.prototype.getDateString = function () {
            var dateString = "";
            if (this.date.getHours() < 10)
                dateString += "0";
            dateString += this.date.getHours() + ":";
            if (this.date.getMinutes() < 10)
                dateString += "0";
            dateString += this.date.getMinutes() + ":";
            if (this.date.getSeconds() < 10)
                dateString += "0";
            dateString += this.date.getSeconds() + ".";
            if (this.date.getMilliseconds() < 10)
                dateString += "00";
            else if (this.date.getMilliseconds() < 100)
                dateString += "0";
            dateString += this.date.getMilliseconds();
            return dateString;
        };
        MessageEntry.prototype.getShortMessage = function () {
            if (this.shortMessageContainsSafeHtml) {
                return this.$sce.trustAsHtml(this.shortMessage);
            }
            else {
                return this.$sce.trustAsHtml(this.sanitizeHtml(this.shortMessage));
            }
        };
        MessageEntry.prototype.getLongMessageUnmodified = function () {
            return this.longMessage;
        };
        MessageEntry.prototype.getLongMessage = function () {
            var completeMessage;
            if (this.longMessageContainsSafeHtml) {
                completeMessage = this.longMessage;
            }
            else {
                completeMessage = this.sanitizeHtml(this.longMessage, false, true);
            }
            var splitToken = "StdOut:";
            var length = 1000;
            var messageHasBeenChanged = false;
            var shortenedMessage = completeMessage;
            if (completeMessage.lastIndexOf(splitToken) != -1) {
                shortenedMessage = completeMessage.split(splitToken)[1];
                messageHasBeenChanged = true;
            }
            if (shortenedMessage.length > length) {
                shortenedMessage = shortenedMessage.substr(0, length - 150) + "...";
                messageHasBeenChanged = true;
            }
            if (messageHasBeenChanged) {
                var javascriptSanitizedMessage = this.sanitizeHtml(this.longMessage, true, true);
                return ("ATTENTION: only showing shortened version of server response. " +
                    "<b>For the full version please click <span style='cursor: pointer;' onclick='var newWindow = window.open();newWindow.document.write(\"" + javascriptSanitizedMessage + "\");'>" +
                    "<u>here</u></span>.</b><br/><hr  style='border:solid #666666 0.3px;height:0px;'>" +
                    shortenedMessage);
            }
            else {
                return completeMessage;
            }
        };
        MessageEntry.prototype.getIgnored = function () {
            return this.ignored;
        };
        MessageEntry.prototype.setIgnored = function () {
            this.ignored = true;
        };
        return MessageEntry;
    }());
    BASWebServices.MessageEntry = MessageEntry;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=MessageBoxController.js.map